import { registerSW } from 'virtual:pwa-register'

// This is the service worker registration function
export function registerServiceWorker() {
  // Register the service worker regardless of environment
  // The plugin will handle development mode internally
  console.log('Registering service worker...')

  // Register the service worker
  const updateSW = registerSW({
    // Called when a new service worker is available
    onNeedRefresh() {
      // You can show a UI to the user asking if they want to refresh
      if (confirm('New content available. Reload to update?')) {
        updateSW(true)
      }
    },
    // Called when the service worker is ready
    onOfflineReady() {
      console.log('App ready to work offline')
      // You can show a notification to the user
      // that the app is ready for offline use
    },
    // Called when the service worker is registered
    onRegistered(registration) {
      console.log('Service worker registered:', registration)
    },
    // Called when there's an error registering the service worker
    onRegisterError(error) {
      console.error('Service worker registration error:', error)
    }
  })
}
